import { OutboundCallStatus } from '@modules/calls/Domain/call.model';
import { TranslateService } from '@ngx-translate/core';

export const OUTBOUND_CALL_STATUS: { id: OutboundCallStatus; description: string }[] = [
  { id: 'completed', description: 'La llamada ha sido completada' },
  { id: 'failed', description: 'No se pudo dar la llamada' },
  { id: 'calling', description: 'LLamada en progreso' },
];

export function mapOutboundCallStatusToFilterOptions(translate: TranslateService) {
  return OUTBOUND_CALL_STATUS.sort((a, b) => a.id.localeCompare(b.id)).map((status) => ({
    label: translate.instant('DATA.COMMON.STATUS.' + status.id),
    value: status.id,
    description: status.description,
  }));
}
